import Swiper, { Navigation, Autoplay } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'swiper/scss/autoplay';
import 'swiper/scss/effect-fade';
const dinamicRecomendations = () => new Promise((resolve, reject) => {
    const last_seen = localStorage.getItem('visited') ? JSON.parse(localStorage.getItem('visited')).last_seen.reverse()[0].id : false;
    if (last_seen) {
        resolve(last_seen);
    }
    else {
        const url = '/collections/all?sort_by=best-selling&section_id=best-selling&limit=1';
        fetch(url)
            .then(response => response.text())
            .then(data => {
            const product = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
            resolve(product);
        })
            .catch(error => reject(error));
    }
});
const handleIntersection = async (entries, observer) => {
    if (!entries[0].isIntersecting)
        return;
    observer.unobserve(productRecommendationsSection);
    const recommendations = document.querySelector('.product-recommendations');
    let product = recommendations.dataset.product;
    if (!recommendations.dataset.product) {
        product = await dinamicRecomendations();
        !product && document.querySelector('.recommendations').remove();
        if (!product)
            return;
    }
    const url = `${recommendations.dataset.url}&product_id=${product}`;
    fetch(url)
        .then(response => response.text())
        .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
            document.querySelector('.product-recommendations').innerHTML = recommendations.innerHTML;
        }
        new Swiper('.products .swiper', {
            modules: [Navigation, Autoplay],
            slidesPerView: 4,
            spaceBetween: 16,
            loop: true,
            speed: 700,
            freeMode: true,
            autoplay: {
                delay: 5500,
            },
            navigation: {
                nextEl: '.products .swiper-button-next',
                prevEl: '.products .swiper-button-prev',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.5,
                },
                768: {
                    slidesPerView: 2.2,
                },
                1024: {
                    slidesPerView: 3.2,
                },
                1200: {
                    slidesPerView: 4,
                },
            },
        });
    })
        .catch(e => {
        console.error(e);
    });
};
const productRecommendationsSection = document.querySelector('.recommendations');
const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: '0px 0px -50px 0px',
    threshold: 0.1
});
observer.observe(productRecommendationsSection);
